export enum AccessType {
    Object = 'Object',
    PermissionSet = 'PermissionSet',
    Profile = 'Profile',
    User = 'User',
}

export enum AccessObjectSource {
    Custom = 'Custom',
    Package = 'Package',
    Standard = 'Standard',
}

export const DataAccessTypePlural = {
	[ AccessType.Object ]: 'Objects',
	[ AccessType.Profile ]: 'Profiles',
	[ AccessType.PermissionSet ]: 'Permission Sets',
	[ AccessType.User ]: 'Users'
};

export enum ObjectPermission {
    create = 'create',
    read = 'read',
    edit = 'edit',
    delete = 'delete',
    viewAllData = 'viewAllData',
    modifyAllData = 'modifyAllData',
}

export enum FieldPermission {
    read = 'read',
    edit = 'edit',
}

export type AccessAuditDetails = PermissionRecords & {
    accessId: string;
    accessName: string;
    accessObjectSource?: AccessObjectSource;
    accessType: AccessType;
    isActive?: boolean;
};

export type AccessObject = {
	name: string;
	type: AccessType,
    sourceUrl?: string;
    userAccessNames?: Array<string>
};

export type PermissionRecords = {
    permissions: Record<string, string>;
};

export type AccessExplainerObject = PermissionRecords & {
    objectId: string;
    objectName: string;
};

export type AccessExplainerField = PermissionRecords &{
    fieldId: string;
    fieldName: string;
    dataSensitivityLevelId: number;
    sonarObjectId: number;
};

export type AccessExplainerDetails = {
    accesses: Record<string, AccessObject>;
    objects: Array<AccessExplainerObject>;
};

export type AccessExplainerObjectDetails = {
    accesses: Record<string, AccessObject>;
    fields: Array<AccessExplainerField>;
};

export type AccessExplainerData = Array<AccessExplainerDetails | AccessExplainerObjectDetails>;
